export enum ConfirmationStatus {
  ALL = 'all',
  ONLY_CONFIRMED = 'only-confirmed',
  ONLY_NOT_CONFIRMED = 'only-not-confirmed',
}
